<template>
  <div>
    <div v-if="loading">
      <div class="text-center my-6">
        <v-progress-circular indeterminate></v-progress-circular>
        <p>{{ $t("chargement") }}</p>
      </div>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" md="4">
          <v-img v-if="produit.photo" :src="produit.photo" width="250" max-height="500" class="mb-3 mr-6" contain></v-img>
        </v-col>
        <v-col cols="12" md="8">
          <div>
            <h1>{{ produit.titre }}</h1>
            <p class="caption mb-0">{{ produit.categorie[$i18n.locale] }}</p>
            <p class="caption mb-0">{{ produit.langue.id ? produit.langue[$i18n.locale] : "" }}</p>
            <p>{{ produit.prix | money }}</p>
            <v-btn color="primary" small @click="ADD_ITEM(produit)">{{ $t("boutique.ajouterAuPanier") }}</v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <p>{{ produit.description[$i18n.locale] }}</p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { Api } from "@/plugins/api"
import { mapActions, mapGetters } from "vuex"
export default {
  data() {
    return {
      loading: true,
      produit: null
    }
  },
  props: {
    id: String
  },
  mounted() {
    this.fetchProduit(this.id)
  },
  computed: {
    ...mapGetters(["typeContact"])
  },
  methods: {
    ...mapActions(["ADD_ITEM"]),
    fetchProduit(id) {
      this.loading = true
      Api.get(`articles/${id}?typeContact=${this.typeContact}`)
        .then((res) => {
          this.produit = res.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
</style>